module.exports = __webpack_public_path__ + "img/lamp-street.2194746f.svg";